import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "containerPublicacoes" }
const _hoisted_2 = { id: "title" }
const _hoisted_3 = { id: "resumo" }
const _hoisted_4 = { id: "keys" }
const _hoisted_5 = { id: "linkpubli" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h1", null, "Baobah: " + _toDisplayString(_ctx.title), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.autores), 1)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Resumo:", -1)),
      _createElementVNode("h3", null, _toDisplayString(_ctx.resumo), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Palavras-chave:", -1)),
      _createElementVNode("h3", null, _toDisplayString(_ctx.palavrasChave), 1)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("a", {
        href: _ctx.link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Acessar", 8, _hoisted_6)
    ])
  ]))
}